import React from 'react'
import { Registry } from '@react-registry'

export const HtmlComment = (props) => {

  return (
    <span {...props.attrs} {...props.attributes} style={{ display: "inline" }} contentEditable={true}>
      {props.children}
    </span>
  )
}

export * from './withHtmlComment'

Registry.register(
  {
    Component: HtmlComment,
    isContentStackElement: true,
    dndOptions: {
      DisableDND: true,
      DisableSelectionHalo: true
    },
    toolbar: {
      inHoveringToolbar: false
    }
  },
  { id: 'html-comment', registry: 'element' }
)